const benchmarks = {
  income: { average: 56000, top25: 92000, top10: 130000 },
  height: { average: 69.1, top25: 71.5, top10: 73.5 },
  age: { average: 37, top25: 30, top10: 26 },
  education: {
    levels: ["High school", "Some college", "Bachelor's", "Master's", "Doctorate"],
    average: "Some college",
    top25: "Bachelor's",
    top10: "Master's"
  }
};

export function scoreUserInput(data) {
  const scores = {};

  for (const trait in data) {
    const val = data[trait];

    if (trait === "education") {
      const order = benchmarks.education.levels;
      const index = order.indexOf(val);
      const avg = order.indexOf(benchmarks.education.average);
      const top25 = order.indexOf(benchmarks.education.top25);
      const top10 = order.indexOf(benchmarks.education.top10);

      if (index >= top10) scores[trait] = "Top 10%";
      else if (index >= top25) scores[trait] = "Top 25%";
      else if (index >= avg) scores[trait] = "Above Average";
      else scores[trait] = "Below Average";

    } else {
      const { average, top25, top10 } = benchmarks[trait] || {};
      const num = Number(val);

      if (isNaN(num)) continue;

      if (trait === "age") {
        if (num <= top10) scores[trait] = "Top 10% (younger)";
        else if (num <= top25) scores[trait] = "Top 25% (younger)";
        else if (num <= average) scores[trait] = "Above Average (younger)";
        else scores[trait] = "Older than average";
      } else {
        if (num >= top10) scores[trait] = "Top 10%";
        else if (num >= top25) scores[trait] = "Top 25%";
        else if (num >= average) scores[trait] = "Above Average";
        else scores[trait] = "Below Average";
      }
    }
  }

  return scores;
}
